import type { App } from "vue";
import { useFlash } from "mu-vue-utils/Composables/flash";
import { formatTlError } from "./tlError";

/**
 * TL calls (findX/getX in onMounted, watchers, event handlers, …) mostly have no try/catch of
 * their own — only save/delete handlers do (docs/notes/index.md). An uncaught TL exception (e.g.
 * AuthTrait::requirePermission()'s "Nemáte oprávnění k této akci.") would otherwise surface only
 * as an unhandled promise rejection in the browser console.
 *
 * app.config.errorHandler covers everything Vue wraps in callWithAsyncErrorHandling — lifecycle
 * hooks (incl. async onMounted), watchers, v-on handlers. window.unhandledrejection is the
 * fallback net for a rejected promise Vue never tracked (outside any component context).
 */
export function installGlobalErrorHandler(app: App): void {
  const { addFlash } = useFlash();

  const reportError = (error: unknown) => {
    console.error(error);
    addFlash(formatTlError(error), 'danger');
  };

  app.config.errorHandler = (err) => reportError(err);

  window.addEventListener('unhandledrejection', (event) => {
    reportError(event.reason);
    event.preventDefault();
  });
}
